import { responseHandler } from '../api/api';
import { post, parseData } from '../api/common';
const getNOCsForCurrentUser = () => {
    return post('/InternalAPI/NOCAPI.asmx/GetNOCsForCurrentUser').then(parseData);
};
const acknowledgeNOCsForCurrentUser = () => {
    return post('/InternalAPI/NOCAPI.asmx/AcknowledgeNOCsForCurrentUser')
        .then(parseData)
        .then(responseHandler);
};
const getNOCDetails = (nocID) => {
    return post('/InternalAPI/NOCAPI.asmx/GetNOCDetails', {
        nocID
    }).then(parseData);
};
export { getNOCsForCurrentUser, acknowledgeNOCsForCurrentUser, getNOCDetails };
